import * as React from 'react';
import { styled } from '../../../theme';
import { MigrateAppPayload } from './MigrateAppPage';
import { useSystem } from '../../../hooks/useSystem';
import { FormikInputWidget } from '../../../widgets/inputs/FormikInput';
import { GroupedButtons } from '../../../widgets/buttons/GroupedButtons';
import { CenterFormOrientation, CenterFormWidget } from '../../../widgets/layout/CenterFormWidget';
import { UnsafeMarkdown } from '../../../widgets/MarkdownWidget';

export interface MigrateAppStep1WidgetProps {
  name: string;
  payload: Partial<MigrateAppPayload>;
  next: (payload: Partial<MigrateAppPayload>) => any;
  onCancel: () => any;
}

export const MigrateAppStep1Widget: React.FC<MigrateAppStep1WidgetProps> = (props) => {
  const system = useSystem();

  const getButtons = () => {
    return (
      <GroupedButtons
        btns={[
          {
            label: 'Cancel',
            action: (event, loading) => {
              props.onCancel();
            }
          },
          {
            label: 'Next',
            action: (event, loading) => {
              props.next({
                ...props.payload
              });
            }
          }
        ]}
      />
    );
  };

  return (
    <CenterFormWidget
      noLogo={true}
      primaryLabel={'Migrate app'}
      secondaryLabel={new UnsafeMarkdown(`**1) App details** > 2) Version control > 3) Confirm`)}
      orientation={CenterFormOrientation.ROW}
    >
      <S.Content>
        <h2>You are about to migrate the app:</h2>
        <S.ContentHighlight>{props.name}</S.ContentHighlight>
        <p>Once your app has been migrated it will be accessible in OXIDE.</p>
        <p>Please note that this process is irreversible.</p>
      </S.Content>
      <S.Ruler />
      {getButtons()}
    </CenterFormWidget>
  );
};

const BASE_LABEL = 'migrate-app-step-1';
namespace S {
  export const StyledInput = styled(FormikInputWidget)`
    label: ${BASE_LABEL}__input;
    max-width: 224px;
  `;

  export const Content = styled.div`
    font-weight: 300;
    color: ${(p) => p.theme.text.primary};

    h1,
    h2,
    h3,
    p {
      margin-bottom: 10px;
    }
  `;

  export const ContentHighlight = styled.h2`
    color: ${(p) => p.theme.text.highlight};
  `;

  export const Ruler = styled.div`
    label: ${BASE_LABEL}__ruler;
    height: 1px;
    background: ${(p) => p.theme.forms.ruler};
    margin-top: 32px;
    margin-bottom: 32px;
  `;
}
